import React, { useEffect, useState } from "react";
import AppButton from "../common/AppButton";
import AppInput from "../common/AppInput";
import config from "../config/config";
import { cloneDeep } from "lodash";

import CheckBox from "../common/CheckBox";
import api from "../config/api";
import moment from "moment";
import findTimeStep from "../hooks/findTimeStep";
import useEmployees from "../hooks/useEmployees";
import LabelText from "../common/LabelText";
import useTasks from "../hooks/useTasks";
import { IoMdTime } from "react-icons/io";
import { FiUser } from "react-icons/fi";
import { toast } from "react-toastify";

const size = config.iconSize;

export default function MultipleTaskAssignModel() {
  const [, setDisabled] = useState(false);
  const Body = ({ onDone, dates, task }) => {
    const tsk = useTasks();
    const addedSlots = tsk.findCurrentTaskSlots({ task });

    const emp = useEmployees();
    const [form, setForm] = useState(
      cloneDeep({
        ...task,
        startTime: { time: task.startTime },
        endTime: { time: task.endTime },
        dates: [
          moment(
            `${moment(task.date).format("DD/MM/YYYY")} hh:mm`,
            "DD/MM/YYYY hh:mm"
          ).toDate(),
        ],
      })
    );
    const [week, setWeek] = useState([]);
    const [employees, setEmployees] = useState(
      Array.isArray(task.employee) ? task.employee : [task.employee]
    );

    const handleSubmit = async (event) => {
      event.preventDefault();
      const error = ["startTime", "endTime", "employee"]
        .reverse()
        .filter((i) => {
          if (form[i].length === 0) {
            document.querySelector("#" + i + " input").focus();
            return i;
          }
          return false;
        });
      if (error.length > 0) return false;
      if (form.dates.length === 0) {
        return alert("Please select available days.");
      }

      setDisabled(true);
      const res = await api.put("tasks", {
        _id: task._id,
        date: form.dates[0],
        startTime: form.startTime.time,
        endTime: form.endTime.time,
        employee: Array.isArray(form.employee)
          ? form.employee.map((i) => i._id)
          : form.employee?._id || form.employee,
      });
      if (!res.ok) {
        setDisabled(false);
        toast.error(res.originalError.message);
      }

      toast.success("Tasks has been successfully scheduled.");
      onDone && onDone();
    };
    const handleChange = ({ target }) => {
      const name = target.name;
      const value = target.value;
      setForm({ ...form, [name]: value });
      fetchAvailability({ ...form, [name]: value });
    };
    const setDates = (value) => {
      let dts = [value.date];

      setForm({ ...form, dates: dts });
      fetchAvailability({ ...form, dates: dts });
    };

    const fetchAvailability = (form) => {
      const dateList = [];
      if (form.startTime && form.endTime && form.dates.length > 0) {
        form.dates.forEach((date) => {
          dateList.push({
            from: moment(
              `${moment(date).format("DD/MM/YYYY")} ${form.startTime.time}`,
              "DD/MM/YYYY hh:mma"
            ).toDate(),
            to: moment(
              `${moment(date).format("DD/MM/YYYY")} ${form.endTime.time}`,
              "DD/MM/YYYY hh:mma"
            ).toDate(),
          });
        });

        const avEmployees = emp
          .availableEmployees({
            dateList,
            formStartTime: form.startTime,
            formEndTime: form.endTime,
            addedSlots,
          })
          .map((i) => i?.employee);

        setEmployees(avEmployees);
      } else {
        setEmployees([]);
      }
    };

    useEffect(() => {
      load();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const load = async () => {
      const week = dates;
      setWeek(week);
    };

    return (
      <form id="form" onSubmit={handleSubmit}>
        <div style={{ padding: "0px 30px" }}>
          <b>
            <p> Available days </p>
          </b>
          <div style={{ display: "flex", gap: "0px 10px" }}>
            {week?.map((dt, ind) => {
              const date = moment(dt.date).format("DD/MM/YYYY");

              const found = form.dates.find(
                (i) => new Date(i).valueOf() === new Date(dt.date).valueOf()
              );

              return (
                <div key={String(ind)}>
                  <div className="d-flex">
                    <CheckBox
                      manual
                      linkChecked={found}
                      value={dt}
                      onClick={setDates}
                      text={moment(dt.date).format("dd").slice(0, 2)}
                      key={String(ind)}
                    />
                  </div>
                  <div
                    className="text-center"
                    style={{ fontSize: 12, color: "gray" }}
                  >
                    {String(date).slice(0, 5)}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <br />
        <div className="d-flex" style={{ gap: 30, padding: "0px 30px" }}>
          <AppInput
            id="startTime"
            name="startTime"
            label="Start Time"
            leftIcon={<IoMdTime size={size} />}
            filterBy="time"
            onChange={handleChange}
            value={form.startTime}
            options={findTimeStep({ start: "00:00am", steps: 30 })}
            type="dropdown"
            floatLabel
          />
          <AppInput
            id="endTime"
            name="endTime"
            label="End Time"
            leftIcon={<IoMdTime size={size} />}
            filterBy="time"
            onChange={handleChange}
            value={form.endTime}
            options={findTimeStep({ start: form?.startTime.time, steps: 30 })}
            type="dropdown"
            floatLabel
          />
        </div>
        <div className="d-flex" style={{ padding: "0px 30px" }}>
          <div>
            <LabelText
              label="Select day and time to enable available assignee"
              labelStyle={{
                color: "silver",
                fontWeight: "500",
              }}
            />
            <AppInput
              id="employee"
              name="employee"
              label="Assignee"
              leftIcon={<FiUser size={size} />}
              filterBy="name"
              onChange={handleChange}
              value={form.employee}
              options={employees}
              type="multi"
              chip
              floatLabel
              disabled={!employees.length > 0}
            />
          </div>
        </div>
        <br />
        <br />

        <br />
        <br />
      </form>
    );
  };
  const Header = () => {
    return (
      <span className="d-flex" style={{ alignItems: "center" }}>
        <b>Multiple Schedule for the week</b>
      </span>
    );
  };
  const Footer = ({ random }) => {
    return (
      <AppButton
        text="Schedule"
        form="form"
        type="submit"
        className="text-primary btn-light"
      />
    );
  };
  return { Header, Body, Footer };
}
